import { jsx } from "react/jsx-runtime";
const CarouselDotButton = ({ dotButtonClasses, dotClasses, index, selected, ...restProps })=>/*#__PURE__*/ jsx("button", {
        "data-testid": "carousel-dot-button",
        className: dotButtonClasses,
        type: "button",
        "aria-label": `Go to slide ${index + 1}`,
        "aria-current": selected ? 'true' : void 0,
        ...restProps,
        children: /*#__PURE__*/ jsx("div", {
            className: dotClasses
        })
    });
export { CarouselDotButton };
